import CallNotification from './callNotification';
import MediaModal from './mediaModal';

const MediaCall = () => {
  return (
    <>
      <CallNotification></CallNotification>
      <MediaModal></MediaModal>
    </>
  );
};

export default MediaCall;
